import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';
import { ProductQueryKeys } from './productQueryKeys';

export type SetProductArchivedVariables = {
    id: string;
    archived: boolean;
};

/**
 * Archives or unarchives a product (BOS-121) — what a product with trading
 * history gets instead of a delete. It leaves the catalog and the POS search
 * and stays readable by id, so past sales keep their name.
 */
export const useSetProductArchivedMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<ApiResponse<void>, Error, SetProductArchivedVariables>({
        mutationFn: ({ id, archived }) =>
            apiClient.products.setProductArchived(id, archived),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: ProductQueryKeys.all,
                });
            }
        },
    });
};
